import React, { Component, Fragment } from "react";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import TextBox from "../../../components/atoms/TextBox";
import ComboBox from "../../../components/atoms/ComboBox";
import TextArea from "../../../components/atoms/TextArea";
import Button from "../../../components/atoms/Button";
import FormRegion from "../FormRegion";
import curencyFormat from "../../../utils/helpers/curencyFormat";

export class DataPerusahaan extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {},
			dataKontakCompany: {},
			fieldOfWork: [],
			companyNumberOfEmployee: [],
			companyType: [],
		};
	}
	updateState = ({ name, value, type }) => {
		// console.log({name, value});
		let { data } = this.state;
		if (value) {
			if (type === "number") {
				value = value.replace(/\D/g, "");
			}
			data[name] = value;
			// console.log("current dara : ", {data});
		} else {
			delete data[name];
		}

		this.setState({ data }, () => {
			console.log(data);
		});
	};
	updateDomicile = ({ name, value, type }) => {
		// console.log({name, value});
		let { data } = this.state;
		if (name === "province") {
			data.domicileInfo.province = value.provinceCode;
			// data.domicileInfo.provinceCode = value.provinceCode
		} else if (name === "city") {
			data.domicileInfo.city = value.cityCode;
			// data.domicileInfo.cityCode = value.cityCode
		} else if (name === "subdistrict") {
			data.domicileInfo.subdistrict = value.subdistrictCode;
			// data.domicileInfo.subdistrictCode = value.subdistrictCode
		} else if (name === "addressKel") {
			data.domicileInfo.addressKel = value.addressKelCode;
			// data.domicileInfo.addressKelCode = value.addressKelCode
		} else {
			data.domicileInfo[name] = value;
		}
		console.log("current dara dom : ", { data });

		this.setState({ data });
	};
	updateStateCompany = ({ name, value, type }) => {
		// console.log({name, value});
		let { dataKontakCompany } = this.state;
		if (value) {
			if (type === "number") {
				value = value.replace(/\D/g, "");
			}
			dataKontakCompany[name] = value;
			// console.log("current dara : ", {dataKontakCompany});
		} else {
			delete dataKontakCompany[name];
		}
		//console.log("current dataKontakCompany = ", { dataKontakCompany });

		this.setState({ dataKontakCompany });
	};
	componentDidMount = () => {
		const { col, parameters, profileState } = this.props;
		let { fieldOfWork, companyNumberOfEmployee, companyType, data, dataKontakCompany } = this.state;
		let dataPerusahaan = profileState.list.customerInfo.corporate;
		let { companyEmail, companyPhone, companyAssetAmount } = profileState.list;
		//console.log({ dataPerusahaan });
		companyEmail && (dataKontakCompany.companyEmail = companyEmail);
		companyPhone && (dataKontakCompany.companyPhoneNumber = companyPhone);
		companyAssetAmount && (dataKontakCompany.companyAssetAmount = companyAssetAmount);

		fieldOfWork = parameters.fieldOfWork;
		companyNumberOfEmployee = parameters.companyNumberOfEmployee;
		companyType = parameters.companyType;
		fieldOfWork.sort(function (a, b) {
			var textA = a.paramName.toUpperCase();
			var textB = b.paramName.toUpperCase();
			return textA < textB ? -1 : textA > textB ? 1 : 0;
		});
		this.setState({ profileState, fieldOfWork, companyNumberOfEmployee, companyType });
		for (let key in dataPerusahaan) {
			if (dataPerusahaan[key]) {
				if (key === "domicileInfo") {
					data.domicileInfo = { country: "Indonesia" };
					for (let k in dataPerusahaan[key]) {
						if (dataPerusahaan.domicileInfo[k] && k !== "isPrimary") {
							data.domicileInfo[k] = dataPerusahaan.domicileInfo[k];
						}
					}
				} else if (key !== "documents" && key !== "cifUID" && key !== "status") {
					data[key] = dataPerusahaan[key];
				}
			}
		}
		this.setState({ data, dataKontakCompany });

		// console.log({parameters, data});
	};
	render() {
		const { col, changeStep, parameters, profileState, submit } = this.props;
		const { data, companyType, fieldOfWork, companyNumberOfEmployee, dataKontakCompany } = this.state;
		return (
			<Fragment>
				{/* <p>{JSON.stringify(data)}</p> */}
				{/* <p>{JSON.stringify(profileState.list.customerInfo)}</p> */}

				<LabelWithInput label="Username" col={col} {...this.props} note={null}>
					<TextBox name="alias_perusahaan" value={data.nickname || ""} onChange={(e) => this.updateState({ name: "nickname", value: e.target.value })} />
				</LabelWithInput>

				<LabelWithInput label="Surel Perusahaan" col={col} {...this.props} note={null}>
					<TextBox name="email_perusahaan" value={dataKontakCompany.companyEmail || ""} onChange={(e) => this.updateStateCompany({ name: "companyEmail", value: e.target.value })} />
				</LabelWithInput>

				<LabelWithInput label="No. Tlp. Perusahaan" col={col} {...this.props} note={null}>
					<TextBox name="no_perusahaan" value={dataKontakCompany.companyPhoneNumber || ""} onChange={(e) => this.updateStateCompany({ name: "companyPhoneNumber", value: e.target.value, type: "number" })} />
				</LabelWithInput>

				<LabelWithInput label="Tipe Perusahaan" col={col} {...this.props} note={null}>
					<ComboBox
						name="tipe_perusahaan"
						title="Tipe Perusahaan"
						fieldName={{ value: "paramValue", text: "paramName" }}
						value={data.companyType}
						data={companyType}
						onChange={(e) => this.updateState({ name: "companyType", value: e.target.value })}
					/>
				</LabelWithInput>

				<LabelWithInput label="Nama Perusahaan" col={col} {...this.props} note={null}>
					<TextBox name="nama_perusahaan" value={data.companyName || ""} onChange={(e) => this.updateState({ name: "companyName", value: e.target.value })} />
				</LabelWithInput>

				<LabelWithInput label="Kategori Usaha" col={col} {...this.props} note={null}>
					<ComboBox
						name="kategori_usaha"
						title="Kategori Usaha"
						fieldName={{ value: "paramValue", text: "paramName" }}
						value={data.companyBusinessType}
						data={fieldOfWork}
						onChange={(e) => this.updateState({ name: "companyBusinessType", value: e.target.value })}
					/>
				</LabelWithInput>

				<LabelWithInput label="Jumlah Karyawan" col={col} {...this.props} note={null}>
					<ComboBox
						name="jumlah_karyawan"
						title="Jumlah Karyawan"
						fieldName={{ value: "paramValue", text: "paramName" }}
						value={data.companyNumberOfEmployee}
						data={companyNumberOfEmployee}
						onChange={(e) => this.updateState({ name: "companyNumberOfEmployee", value: e.target.value })}
					/>
				</LabelWithInput>

				<LabelWithInput label="Omzet per Bulan" col={col} {...this.props} note={null}>
					<ComboBox
						name="companyMonthlyIncome"
						title="Omzet per Bulan"
						fieldName={{ value: "paramValue", text: "paramName" }}
						value={data.companyMonthlyIncome}
						data={parameters.monthlyIncome}
						onChange={(e) => this.updateState({ name: "companyMonthlyIncome", value: e.target.value })}
					/>
				</LabelWithInput>

				<LabelWithInput label="Jumlah Aset (Dalam Rupiah)" col={col} {...this.props}>
					<TextBox
						onChange={(e) => this.updateStateCompany({ name: "companyAssetAmount", value: e.target.value, type: "number" })}
						value={dataKontakCompany.companyAssetAmount ? curencyFormat(dataKontakCompany.companyAssetAmount) : 0}
						name="companyAssetAmount"
					/>
				</LabelWithInput>

				<LabelWithInput label="Berdiri Sejak" col={col} {...this.props} note={null}>
					<TextBox name="sejak" type={"number"} opts={{ maxLength: 4 }} value={data.companySince || ""} onChange={(e) => this.updateState({ name: "companySince", value: e.target.value, type: "number" })} />
				</LabelWithInput>

				<LabelWithInput label="Deskripsi Perusahaan" col={col} {...this.props} note={null}>
					<TextArea name="deskripsi" value={data.companyDescription || ""} onChange={(e) => this.updateState({ name: "companyDescription", value: e.target.value })} />
				</LabelWithInput>

				<LabelWithInput label="Negara" col={col} {...this.props} note={null}>
					<TextBox name="negara" value={(data.domicileInfo && data.domicileInfo.country) || ""} isDisabled />
				</LabelWithInput>

				{data.domicileInfo && <FormRegion col={col} changeState={this.updateDomicile} data={data.domicileInfo} />}

				<LabelWithInput label="Alamat" col={col} {...this.props} note={null}>
					<TextArea name="alamat" value={(data.domicileInfo && data.domicileInfo.address) || ""} onChange={(e) => this.updateDomicile({ name: "address", value: e.target.value })} />
				</LabelWithInput>

				<div className="bg-button add-margin">
					<Button onClick={() => submit(data, dataKontakCompany, true)} width="big" color="outline" title="Sebelumnya" />
					<Button onClick={() => submit(data, dataKontakCompany, false)} width="big" color="blue" title="Selanjutnya" />
				</div>
			</Fragment>
		);
	}
}

export default DataPerusahaan;
